const DATE_SECOND = 1;
const DATE_MINUTE = DATE_SECOND * 60;
const DATE_HOUR = DATE_MINUTE * 60;
const DATE_DAY = DATE_HOUR * 24;

interface ISiteElementCloseConfig
{
    days: string;
    day: string;
    hours: string;
    hour: string;
    minutes: string;
    minute: string;
    seconds: string;
    second: string;
}

class SiteElementClose
    extends QueryElement<HTMLElement> {
    
    private readonly _dateTime: Date;
    private readonly _countdown: any;
    private readonly _config: ISiteElementCloseConfig;

    constructor(element: HTMLElement, dateTime: Date) {
        super(element);
        
        this._config = QueryJSON.deserialize<ISiteElementCloseConfig>(this.getAttr("data-config") || "{}");
        this._dateTime = dateTime;
        this._countdown = this.query(".countdown").first();
        this.loop();
    }

    loop() {
        var time = this._dateTime.getTime() - new Date().getTime() / 1000;
        
        var toReturn = [];
        if (time > DATE_DAY) {
            var days = Math.floor(time / DATE_DAY);
            toReturn.push(`${days} ${days > 1 ? this._config.days : this._config.day}`);
            time = time % DATE_DAY;
        }

        if (time > DATE_HOUR) {
            var hours = Math.floor(time / DATE_HOUR);
            toReturn.push(`${hours} ${hours > 1 ? this._config.hours : this._config.hour}`);
            time = time % DATE_HOUR;
        }

        if (time > DATE_MINUTE) {
            var minutes = Math.floor(time / DATE_MINUTE);
            toReturn.push(`${minutes} ${minutes > 1 ? this._config.minutes : this._config.minute}`);
            time = time % DATE_MINUTE;
        }

        if (time > DATE_SECOND) {
            var seconds = Math.floor(time / DATE_SECOND);
            toReturn.push(`${seconds} ${seconds > 1 ? this._config.seconds : this._config.second}`);
        }

        this._countdown.setHtml(toReturn.join(" "));

        window.setTimeout(() => this.loop(), 1000);
    }
}